import onEscape from '~/directives/escape'
import onClickOutside from '~/directives/click-outside'

export default {
  directives: {
    escape: onEscape,
    clickOutside: onClickOutside
  },

  methods: {
    dismiss() {
      this.$emit('close')
    }
  }
}
